// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__1XhnD","emoji":"navbar_emoji__pXmz9","chat":"navbar_chat__kA-bs"};